import { render, staticRenderFns } from "./MyLessonsMain.vue?vue&type=template&id=7bf5aefc&scoped=true"
import script from "./MyLessonsMain.vue?vue&type=script&lang=js"
export * from "./MyLessonsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf5aefc",
  null
  
)

export default component.exports